import { useContext } from "react";
import { SingleOrderContext } from './SingleOrderContext'

export const useMode = () => {
    const context = useContext(SingleOrderContext);
    if (!context) {
        throw new Error("useMode must be used within a ModeProvider");
    }
    return context;
};